export default __webpack_public_path__ + "static/media/icon-close.c3904486.svg";